// employees data
const Employees = [
    {
      id: 1,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/001.png',
      firstName: 'Bulbasaur',
      lastName: 'Green',
      title: 'Mr',
      phone: '0400 987 654',
      email: 'bulb.lake@gmail.com',
    },
    {
      id: 4,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/004.png',
      firstName: 'Charmander',
      lastName: 'Red',
      title: 'Mrs',
      phone: '0433 666 888',
      email: 'charmander@gmail.com',
    },
    {
      id: 7,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/007.png',
      firstName: 'Squirtle',
      lastName: 'Blue',
      title: 'Mr',
      phone: '0412 345 678',
      email: 'squirtle@gmail.com',
    },
    {
      id: 8,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/008.png',
      firstName: 'Wartortle',
      lastName: 'Blue',
      title: 'Ms',
      phone: '0412 343 688',
      email: 'warwar@gmail.com',
    },
    {
      id: 10,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/010.png',
      firstName: 'Caterpie',
      lastName: 'Green',
      title: 'Miss',
      phone: '0488 775 008',
      email: 'cater10@gmail.com',
    },
    {
      id: 12,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/012.png',
      firstName: 'Butterfree',
      lastName: 'Purple',
      title: 'Mrs',
      phone: '0412 111 222',
      email: 'butterbutter@gmail.com',
    },
    {
      id: 39,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/039.png',
      firstName: 'Jigglypuff',
      lastName: 'Pink',
      title: 'Miss',
      phone: '0412 234 777',
      email: 'jiggly39@gmail.com',
    },
    {
      id: 25,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/025.png',
      firstName: 'Pikachu',
      lastName: 'Yellow',
      title: 'Mr',
      phone: '0412 000 557',
      email: 'chuchu25@gmail.com',
    },
    {
      id: 69,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/069.png',
      firstName: 'Bellsprout',
      lastName: 'Yellow Green',
      title: 'Ms',
      phone: '0477 444 227',
      email: 'bella69@gmail.com',
    },
    {
      id: 151,
      picture: 'https://assets.pokemon.com/assets/cms2/img/pokedex/detail/151.png',
      firstName: 'Mew',
      lastName: 'Pink',
      title: 'Miss',
      phone: '0412 334 875',
      email: 'mewmew@gmail.com',
    }
  ];

  export default Employees;